import "bootstrap4-notify"

const {notify} = require("../util/notify")

export default class NotificationQueue {
  constructor(NotificationID) {
    this.requestUrl =
      "/Admin/WebServices/NotificationLogWebService.asmx/GetNotificationLogs"
    this.requestData = []
    this.requestParameters = {}

    this.notificationID = 0

    if (NotificationID) {
      this.notificationID = NotificationID
    }
  }

  async render() {
    await this.getData()
    this.drawNotifications()
  }

  async getData() {
    this.requestData = await window.session.request(this.requestUrl, {
      id: this.notificationID,
    })
    if (this.requestData.NotificationLogs.length > 0) {
      this.notificationID = this.requestData.NotificationLogs[
        this.requestData.NotificationLogs.length - 1
      ].NotificationLogID
    }
  }

  drawNotifications() {
    let messageDelay = 0
    if (
      window.session.currentUser &&
      window.session.currentUser.NotificationDismissed
    ) {
      messageDelay = 5000
    }

    this.requestData.NotificationLogs.forEach(item => {
      let message = window.session.translations["Notification" + item.Action]

      message = message.replace("[Username]", item.UserName)
      message = message.replace(
        "[Subject]",
        window.session.translations["Notification" + item.Subject],
      )
      message = message.replace("[KeyValues]", item.KeyValues)

      notify({message, messageDelay, type: "info"})
    })
  }

  getNotificationID() {
    return this.notificationID
  }
}
